<template>
  <Popover
    v-if="popover"
    :header="popover.header"
    :title="popover.title"
    :message="popover.message"
    :helpLink="popover.helpLink"
    position="left"
    inner-class="tw-w-full"
    :testId="testId"
  >
    <slot />
  </Popover>
  <slot v-else />
</template>

<script>
import Popover from "@/components/display/Popover";

export default {
  name: "DropDownItemPopover",
  components: {
    Popover,
  },
  props: {
    popover: {
      type: Object,
    },
    testId: String,
  },
};
</script>
